import ProjectWebscannerSidebarWidgetModule from './sidebar-widget.module'

export default ProjectWebscannerSidebarWidgetModule
